import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, put } from "helpers/api_helper";
import {
  GET_ALL_NOTIFICATIONS,
  SEND_NOTIFICATION,
  UPDATE_NOTIFICATION,
} from "helpers/url_helper";

export const getAllNotifications = createAsyncThunk(
  GET_ALL_NOTIFICATIONS,
  async (payload) => {
    const response = await post(GET_ALL_NOTIFICATIONS, payload);
    return response;
  }
);

export const sendNotification = createAsyncThunk(
  SEND_NOTIFICATION,
  async (payload) => {
    const response = await post(SEND_NOTIFICATION, payload);
    return response;
  }
);

export const updateNotification = createAsyncThunk(
  UPDATE_NOTIFICATION,
  async (payload) => {
    const response = await put(UPDATE_NOTIFICATION, payload);
    return response;
  }
);
